// extracted by mini-css-extract-plugin
export default {"priceExp":"index_priceExp__b8ndM","title":"index_title__pr0md","img":"index_img__moww5"};